const path = "./static/themes/mario/audio/";

export const marioConfig = {
  intro: [
    `${path}theme.mp3`,
    `${path}mario3-theme.mp3`,
    `${path}Grass_Land_-_Super_Mario_Bros_3.mp3`,
    `${path}Overworld_-_Super_Mario_Bros_2.mp3`,
    `${path}Player_Select_-_Super_Mario_Bros_2.mp3`,
    `${path}Super_Mario_Bros_Music_-_Underground.mp3`,
    `${path}Super_Mario_Bros_Music_-_Underwater.mp3`,
    `${path}Title_Screen_-_Super_Mario_Bros_2.mp3`,
  ],
  win: [
    `${path}smb_stage_clear.wav`,
    `${path}smb_world_clear.wav`,
  ],
  loose: [
    `${path}smb_gameover.wav`
  ],
  choice: `${path}choice.mp3`,
  simple: [
    `${path}sm64_mario_waha.wav`,
    `${path}sm64_mario_boing.wav`,
    `${path}sm64_mario_doh.wav`,
    `${path}sm64_mario_yippee.wav`
  ]
};
